/* Núvo — "Often ordered together" companion bar.
   Live count + running total on checkbox change; one POST /cart/add.js for all
   selected items. The drawer auto-opens via nuvo-cart-open.js (which observes
   /cart/add.js POSTs), so we don't touch the drawer here. */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents, fmt) {
    var value = (cents / 100).toFixed(2);
    var out = (fmt || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
    // amount_no_decimals fallback if that's the store's format
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    return out;
  }

  function initCompanions(rootEl) {
    if (rootEl.__nuvoCompanionsInit) return;
    rootEl.__nuvoCompanionsInit = true;

    var fmt = rootEl.getAttribute('data-money-format') || '£{{amount}}';
    var checks = Array.prototype.slice.call(rootEl.querySelectorAll('[data-companion-check]'));
    var countEl = rootEl.querySelector('[data-companion-count]');
    var totalEl = rootEl.querySelector('[data-companion-total]');
    var addBtn = rootEl.querySelector('[data-companion-add]');
    var addLabel = rootEl.querySelector('[data-companion-add-label]');
    if (!checks.length || !addBtn) return;

    var busy = false;

    function selected() {
      return checks.filter(function (c) { return c.checked; });
    }

    function refresh() {
      var sel = selected();
      var cents = sel.reduce(function (sum, c) {
        return sum + (parseInt(c.getAttribute('data-price'), 10) || 0);
      }, 0);
      if (countEl) countEl.textContent = String(sel.length);
      if (totalEl) totalEl.textContent = formatMoney(cents, fmt);
      addBtn.disabled = busy || sel.length === 0;
      // reflect selected state on the card for styling
      checks.forEach(function (c) {
        var card = c.closest('[data-companion-card]');
        if (card) card.classList.toggle('is-selected', c.checked);
      });
    }

    function setBusy(state) {
      busy = state;
      rootEl.classList.toggle('is-busy', state);
      if (addLabel) {
        addLabel.textContent = state ? 'Adding…' : 'Add selected items';
      }
      refresh();
    }

    function add() {
      var sel = selected();
      if (!sel.length || busy) return;
      var items = sel.map(function (c) {
        return { id: Number(c.getAttribute('data-variant-id')), quantity: 1 };
      });
      setBusy(true);
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          // clear the picker; the drawer opens via nuvo-cart-open.js
          checks.forEach(function (c) { c.checked = false; });
          if (addLabel) addLabel.textContent = 'Added ✓';
          setTimeout(function () { setBusy(false); }, 900);
        })
        .catch(function () {
          if (addLabel) addLabel.textContent = 'Try again';
          setTimeout(function () { setBusy(false); }, 1200);
        });
    }

    checks.forEach(function (c) {
      c.addEventListener('change', refresh);
    });
    addBtn.addEventListener('click', add);
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-companions]').forEach(initCompanions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
